import React, { createContext, useEffect, useState } from 'react';
import { StateSnapshot } from "react-virtuoso";

// Define a context for managing scroll state
interface ScrollContextType {
  snapShot: StateSnapshot,
  setSnapShot: React.Dispatch<React.SetStateAction<StateSnapshot>>;
  profileSnapShot: StateSnapshot;
  setProfileSnapShot: React.Dispatch<React.SetStateAction<StateSnapshot>>;
  exploreSnapShot: StateSnapshot;
  setExploreSnapShot: React.Dispatch<React.SetStateAction<StateSnapshot>>;
}

const ScrollContext = createContext<ScrollContextType>({
  snapShot: { scrollTop: 0, ranges: [] },
  setSnapShot: () => {
  },
  profileSnapShot: { scrollTop: 0, ranges: [] },
  setProfileSnapShot: () => { },
  exploreSnapShot: { scrollTop: 0, ranges: [] },
  setExploreSnapShot: () => { },
});

// ScrollProvider component to wrap your application
export const ScrollProvider = ({ children }: { children: React.ReactNode }) => {
  const [snapShot, setSnapShot] = useState<StateSnapshot>({ scrollTop: 0, ranges: [] });
  const [profileSnapShot, setProfileSnapShot] = useState<StateSnapshot>({ scrollTop: 0, ranges: [] });
  const [exploreSnapShot, setExploreSnapShot] = useState<StateSnapshot>({ scrollTop: 0, ranges: [] });

  useEffect(() => {
    if (snapShot && snapShot.scrollTop !== 0) {
      sessionStorage.setItem("scrollTop", snapShot.scrollTop.toString());
    }
  }, [snapShot]);

  useEffect(() => {
    // Persist profile snapshot in sessionStorage
    if (profileSnapShot && profileSnapShot.scrollTop !== 0) {
      sessionStorage.setItem("profileScrollTop", profileSnapShot.scrollTop.toString());
    }
  }, [profileSnapShot]);

  useEffect(() => {
    // Persist explore snapshot in sessionStorage
    if (exploreSnapShot && exploreSnapShot.scrollTop !== 0) {
      sessionStorage.setItem("exploreScrollTop", exploreSnapShot.scrollTop.toString());
    }
  }, [exploreSnapShot]);

  return (
    <ScrollContext.Provider value={{ snapShot, setSnapShot, profileSnapShot, setProfileSnapShot, exploreSnapShot, setExploreSnapShot }}>
      {children}
    </ScrollContext.Provider>
  );
};

// Custom hook to access scroll context
export const useScroll = () => {
  const context = React.useContext(ScrollContext);
  if (!context) {
    throw new Error('useScroll must be used within a ScrollProvider');
  }
  return context;
};
